module.exports = __webpack_public_path__ + "static/media/marker_icon_lab.9a61d064.svg";